const getters = {
	themeColor(state, getters) {
		return state.themeColor;
	},

	appname(state) {
		return state.appname;
	},

	virtualCurrencyUnit(state, getters) {
		return state.virtualCurrencyUnit;
	},

	appid(state) {
		return state.appid;
	},

	redirectURL(state) {
		return state.redirectURL;
	}
};

export default getters